import React from 'react';
import { Link } from 'react-router-dom';
import './CtaCards.css';

const cards = [
  {
    img: 'cta-custom.png',
    eyebrow: 'CUSTOM BUILT. YOUR WAY.',
    title: 'Your ATV.\nYour Vision.',
    text: "Choose upgrades, accessories, and custom options to build an ATV that's uniquely yours.",
    link: 'Customize Your Ride',
    href: '/accessories',
  },
  {
    img: 'cta-defence.png',
    eyebrow: 'TRUSTED. PROVEN. RELIABLE.',
    title: 'Trusted By Defence.\nEngineered For\nThe Future.',
    text: 'Built with advanced technology and backed by defence-grade standards for mission-ready performance.',
    link: 'Learn More',
    href: '/defence',
  },
  {
    img: 'cta-global.png',
    eyebrow: 'GLOBAL VISION',
    title: 'Expanding\nBeyond Borders',
    text: 'From domestic excellence to global presence, Acriolis is coming to key markets worldwide.',
    link: 'View Our Global Vision',
    href: '/about',
  },
];

function CtaCards() {
  return (
    <section className="ctacards">
      <div className="ctacards__inner">
        {cards.map((c) => (
          <Link
            className="ctacard"
            key={c.eyebrow}
            to={c.href}
            style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/${c.img})` }}
          >
            <div className="ctacard__content">
              <span className="ctacard__eyebrow">{c.eyebrow}</span>
              <h3 className="ctacard__title">
                {c.title.split('\n').map((line, i) => (
                  <React.Fragment key={i}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </h3>
              <p className="ctacard__text">{c.text}</p>
              <span className="ctacard__link">
                {c.link} <span className="ctacard__arrow">→</span>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}

export default CtaCards;
